import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';

const ProgramList = (props) => {
    const handleSelectionChanged = (e) => {
        props.onSelectionChanged(e)
    }

    const handleSelect = (e) => {
        props.getProgram(e.id);
        props.history.push(`/programs/program/${e.id}`);
    };

    return (
        <div className="ag-theme-balham">
            <DataGrid
                rows={props.trainingPrograms?.map(x => { return { id: x.programId, ...x } })}
                onRowDoubleClick={handleSelect}
                checkboxSelection
                onRowSelectionModelChange={handleSelectionChanged}
                autoHeight={true}
                rowHeight={35}
                initialState={{
                    pagination: { paginationModel: { pageSize: 25 } },
                }}
                columns={[
                    {
                        headerName: 'Jurisdiction State',
                        field: 'jurisdictionState',
                        flex: 3,
                    },
                    {
                        headerName: 'Program Name',
                        field: 'name',
                        flex: 3,
                    },
                    {
                        headerName: 'Jurisdiction',
                        field: 'jurisdiction',
                        flex: 3,
                    },
                    {
                        headerName: 'Court Type',
                        field: 'courtType',
                        flex: 3,
                    },
                ]}
                sx={{
                    backgroundColor: 'white'
                }}
                getRowClassName={(params) => 'grid-row'}
            />
        </div>
    );
};

export default ProgramList;


